import React, { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { updateCampaignTitle, deleteCampaign, removeSharedCampaign } from "../../../../services/api";
import toast from "react-hot-toast";

const EditCampaignModal = ({ isOpen, onClose, campaign, isShared = false }) => {
  const [mode, setMode] = useState(null);
  const [newName, setNewName] = useState("");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [password, setPassword] = useState("");

  const handleAction = () => {
    if (mode === "rename") {
      if (!newName.trim()) {
        toast.error("Please enter a valid name");
        return;
      }
      setShowConfirmation(true);
    } else if (mode === "delete") {
      if (!password.trim()) {
        toast.error("Please enter your password");
        return;
      }
      handleConfirm();
    }
  };

  const handleConfirm = async () => {
    try {
      if (mode === "rename") {
        await updateCampaignTitle(campaign.id, newName);
        toast.success("Campaign renamed successfully");
        resetAndClose();
        window.location.reload();
      } else if (mode === "delete") {
        try {
          const result = await deleteCampaign(campaign.id, password);
          if (result && result.success) {
            toast.success("Campaign deleted successfully");
            resetAndClose();
            window.location.reload();
          }
        } catch (error) {
          toast.error(error.message);
          setPassword("");
        }
      } else if (mode === "remove") {
        try {
          const result = await removeSharedCampaign(campaign.share_id);
          if (result && result.success) {
            toast.success(result.message);
            resetAndClose();
            window.location.reload();
          }
        } catch (error) {
          toast.error(error.message);
        }
      }
    } catch (error) {
      toast.error(error.message);
      if (mode !== "delete" && mode !== "remove") {
        resetAndClose();
      }
    }
  };

  const resetAndClose = () => {
    setMode(null);
    setNewName("");
    setShowConfirmation(false);
    setPassword("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="relative w-full max-w-md bg-white rounded-lg p-6">
        <button
          onClick={resetAndClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
          <IoCloseOutline size={24} />
        </button>

        <h2 className="text-xl font-semibold mb-6 text-black">Campaign Editor</h2>

        {!mode ? (
          <div className="space-y-4">
            {!isShared ? (
              <>
                <button
                  onClick={() => {
                    setMode("rename");
                    setNewName(campaign?.title || "");
                  }}
                  className="w-full p-3 text-left text-black bg-gray-50 hover:bg-gray-100 rounded-lg">
                  Rename Campaign
                </button>
                <button
                  onClick={() => setMode("delete")}
                  className="w-full p-3 text-left bg-red-50 hover:bg-red-100 text-red-600 rounded-lg">
                  Delete Campaign
                </button>
              </>
            ) : (
              <button
                onClick={() => {
                  setMode("remove");
                  setShowConfirmation(true);
                }}
                className="w-full p-3 text-left bg-red-50 hover:bg-red-100 text-red-600 rounded-lg">
                Remove from Shared with me
              </button>
            )}
          </div>
        ) : showConfirmation ? (
          <div className="space-y-4">
            <p className="text-black">
              {mode === "rename" ? `Rename campaign to "${newName}"?` : 
               mode === "remove" ? `Remove "${campaign?.title}" from Shared with me?` : 
               "Are you sure?"}
            </p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => setShowConfirmation(false)}
                className="px-4 py-2 text-black bg-gray-100 hover:bg-gray-200 rounded-lg">
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                className={`px-4 py-2 text-white rounded-lg ${
                  mode === "remove" ? "bg-red-600 hover:bg-red-700" : "bg-primary hover:bg-primary-light"
                }`}>
                {mode === "remove" ? "Yes, Remove" : "Confirm"}
              </button>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            {mode === "rename" ? (
              <div>
                <label className="block text-sm font-medium text-black mb-2">
                  New Campaign Name
                </label>
                <input
                  type="text"
                  value={newName}
                  onChange={(e) => setNewName(e.target.value)}
                  className="w-full p-2 text-black border border-gray-300 rounded-lg"
                  placeholder="Enter new name"
                />
              </div>
            ) : mode === "delete" ? (
              <div className="space-y-4">
                <div className="p-4 bg-red-50 rounded-lg">
                  <p className="text-red-600 font-medium mb-2">Warning</p>
                  <p className="text-red-600">
                    This will permanently delete the campaign "{campaign?.title}". This action cannot be undone.
                    You can only delete campaigns that have no transcripts.
                  </p>
                </div>
                <div>
                  <label className="block text-sm font-medium text-black mb-2">
                    Enter Your Password to Confirm Deletion
                  </label>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full p-2 text-black border border-gray-300 rounded-lg"
                    placeholder="Enter your password"
                  />
                </div>
              </div>
            ) : null}
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => setMode(null)}
                className="px-4 py-2 text-black bg-gray-100 hover:bg-gray-200 rounded-lg">
                Back
              </button>
              <button
                onClick={handleAction}
                className={`px-4 py-2 text-white rounded-lg ${
                  mode === "delete" ? "bg-red-600 hover:bg-red-700" : "bg-primary hover:bg-primary-light"
                }`}>
                {mode === "delete" ? "Delete Permanently" : "Continue"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditCampaignModal; 